export const EGYPTIAN_MOBILE_PREFIXES = ['010', '011', '012', '015'];

export const EGYPTIAN_MOBILE_LOCAL_REGEX = /^(010|011|012|015)\d{8}$/;

export const EGYPTIAN_MOBILE_HELP_TEXT =
  '11 digits starting with 010, 011, 012, or 015 (e.g. 012xxxxxxxx)';

export function cleanPhoneDigits(value) {
  return (value || '').replace(/\D/g, '');
}

export function isValidEgyptianMobileLocal(digits) {
  return EGYPTIAN_MOBILE_LOCAL_REGEX.test(cleanPhoneDigits(digits));
}

export function getEgyptianMobileValidationError(digits) {
  const cleaned = cleanPhoneDigits(digits);

  if (!cleaned) {
    return 'Please enter your phone number';
  }

  if (cleaned.length !== 11) {
    return 'Egyptian mobile numbers must be exactly 11 digits (e.g. 012xxxxxxxx)';
  }

  const prefix = cleaned.slice(0, 3);
  if (!EGYPTIAN_MOBILE_PREFIXES.includes(prefix)) {
    return 'Number must start with 010 (Vodafone), 011 (Etisalat), 012 (Orange), or 015 (We)';
  }

  return null;
}

export function isValidPhoneForCountry(countryCode, localDigits) {
  const cleaned = cleanPhoneDigits(localDigits);
  if (countryCode === '+20') {
    return isValidEgyptianMobileLocal(cleaned);
  }
  return /^[0-9]{8,15}$/.test(cleaned);
}

export function getPhoneValidationError(countryCode, localDigits) {
  if (countryCode === '+20') {
    return getEgyptianMobileValidationError(localDigits);
  }

  const cleaned = cleanPhoneDigits(localDigits);
  if (!cleaned) {
    return 'Please enter your phone number';
  }
  if (!/^[0-9]{8,15}$/.test(cleaned)) {
    return 'Please enter a valid phone number (8–15 digits)';
  }
  return null;
}

/** Build E.164 number (+20XXXXXXXXXX) from local Egyptian mobile digits. */
export function buildFullPhoneNumber(countryCode, localDigits) {
  const cleaned = cleanPhoneDigits(localDigits);

  if (countryCode === '+20') {
    if (!isValidEgyptianMobileLocal(cleaned)) {
      return null;
    }
    return `+20${cleaned.slice(1)}`;
  }

  if (!/^[0-9]{8,15}$/.test(cleaned)) {
    return null;
  }

  return `${countryCode}${cleaned}`;
}
